import { render, staticRenderFns } from "./typeCategory.vue?vue&type=template&id=59836316&scoped=true&"
import script from "./typeCategory.vue?vue&type=script&lang=js&"
export * from "./typeCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59836316",
  null
  
)

export default component.exports